module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePage_TH_Euro_Mobile.12655c64.webp";